import React from 'react';
import { services } from '../mock';
import { Shield, FileText, Lightbulb, Building } from 'lucide-react';
import { Card } from './ui/card';

const iconComponents = {
  Shield,
  FileText,
  Lightbulb,
  Building
};

const ServicesSection = () => {
  // Modern abstract background images for each service
  const serviceImages = {
    1: 'https://images.unsplash.com/photo-1553532434-5ab5b6b84993', // Trademark - Geometric triangles
    2: 'https://images.unsplash.com/photo-1684139517679-032b7213ad2e', // Copyright - Blue/purple gradient
    3: 'https://images.unsplash.com/photo-1710244182004-1c708b3f146d', // Patent - 3D colorful shapes
    4: 'https://images.unsplash.com/photo-1605106702734-205df224ecce'  // Company - Blue geometric pattern
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-[#F97316] uppercase tracking-wide mb-2" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
            OUR SERVICES
          </p>
          <h2 className="text-4xl font-bold text-[#012169] mb-4">
            Our IP Protection Services
          </h2>
          <p className="text-base text-gray-600 max-w-3xl mx-auto">
            From trademark registration to patent filings, we provide comprehensive legal services to protect every aspect of your intellectual property.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => {
            const IconComponent = iconComponents[service.icon];
            return (
              <Card
                key={service.id}
                className="group relative overflow-hidden bg-white hover:shadow-2xl transition-all duration-500 border-2 border-gray-100 hover:border-[#FFD700] rounded-2xl h-80"
              >
                {/* Background Image with Overlay */}
                <div 
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                  style={{
                    backgroundImage: `url(${serviceImages[service.id]})`,
                  }}
                >
                  <div className="absolute inset-0 bg-gradient-to-b from-[#012169]/80 via-[#012169]/85 to-[#012169]/95 group-hover:from-[#012169]/85 group-hover:to-[#F97316]/95 transition-all duration-500"></div>
                </div>

                {/* Content */}
                <div className="relative z-10 p-6 flex flex-col h-full">
                  <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mb-4 group-hover:bg-[#F97316] group-hover:scale-110 transition-all duration-300 border-2 border-white/30">
                    <IconComponent className="h-8 w-8 text-white group-hover:text-white" />
                  </div>
                  
                  <h3 className="text-2xl font-bold text-white mb-3">
                    {service.title}
                  </h3>
                  
                  <p className="text-base text-white/90 leading-relaxed">
                    {service.description}
                  </p>

                  {/* Bottom gradient bar */}
                  <div className="absolute bottom-0 left-0 right-0 h-1.5 bg-gradient-to-r from-[#F97316] to-[#8B5CF6] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;